import { 
    VCard,
} from 'vuetify/lib'
import PayDetail from './Pay_Detail'
import PayTable from './Pay_Table'
import {getCustomerMonthSalaryTotalCurrentMonthPayApi} from '../service'
export default {
    props: {
        tab: { // 1: 正式员工;2:销服团队;3:劳务派遣;4:外包员工
            type: Number
        }
    },
    data() {
        return {
            // tab_list: [
            //     {
            //         label: '正式员工',
            //         value: 1,
            //     },
            //     {
            //         label: '销服团队',
            //         value: 2,
            //     },
            //     {
            //         label: '劳务派遣',
            //         value: 3,
            //     },
            //     {
            //         label: '外包员工',
            //         value: 4,
            //     },
            // ],
         //   tab: 1,
            currentMonthShouldPay: null,
        }
    },
    computed: {
        is_detail() {
            return this.$route.query && this.$route.query.id !== undefined
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        getCustomerMonthSalaryTotalCurrentMonthPay(tab) {
            getCustomerMonthSalaryTotalCurrentMonthPayApi({type:100, order_type:tab}).then(res => {
              this.currentMonthShouldPay = res.currentMonth && res.currentMonth.currentMonthShouldPay
            })
        },
        initData() {
            if (this.is_detail) {
                this.$refs.detail.getData()
            } else {
                this.changeTab()
            }
        },
        changeTab() {
            this.$nextTick(() => {
                this.$refs.table && this.$refs.table.getData(this.tab)
              //   this.getCustomerMonthSalaryTotalCurrentMonthPay(this.tab)
            })
        }
    },
    render() {
      const _this = this
      return <VCard>
         
            <div>
               <div style={{
                   display: _this.is_detail ? 'none' : 'block'
               }}>
                {/* <VRadioGroup
                    v-model={_this.tab}
                    row
                    on={{
                        change: () => {
                            _this.changeTab()
                        }
                    }}
                >
               {_this.tab_list.map(item => <VRadio key={item.value}
                    value={item.value}
                    label={item.label}
                />)}
           </VRadioGroup> */}
                <p>系统将自动按计薪周期生成薪资详情，可对外发布收集信息并归档。</p>
                <PayTable
                    type={this.tab}
                    currentMonthShouldPay={this.currentMonthShouldPay}
                    on={{
                        getDetail:(target) => {
                            _this.$router.push(`/hr/payment-manage/official-p-r?id=${target.id}&tab=${_this.tab}`).then(() => {
                                _this.$refs.detail.getData()
                            })
                        }
                    }}
                    ref="table"
                /> 
               </div>
           </div>
           <div style={{
                   display: _this.is_detail ? 'block' : 'none'
               }}>
                    <PayDetail 
                        ref="detail"
                        on={{
                            back:() => {
                                _this.changeTab()
                            }
                        }}
                    />
           </div>
      </VCard>  
    }
}